import "./Curations.module.css";
import Header from "@/reusable_sections/Header";
import ServiceTiers from "./sections/ServiceTiers";
import MainSiteFooter from "@/reusable_sections/Footer";
export default function CurationsPage() {
  return <div>
      <Header />
      <ServiceTiers />
      <MainSiteFooter />
    </div>;
}